
const TableNoDataComponent = () =>
{

    return (
        <div className='no-data-message-div'>
            <p className='no-data-message'>No data available</p>
        </div>
    )
}

export default TableNoDataComponent;